import { render } from "./ExchangePage.vue?vue&type=template&id=cb659f32"
import script from "./ExchangePage.vue?vue&type=script&lang=js"
export * from "./ExchangePage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__